import Component from '../core/Component'
import EventBus from '../core/EventBus'

const STATES = {
    ACTIVE: 'is-open',
}

export default class Lock extends Component {
    prepare() {
        this.element.addEventListener('click', this.handleClick)
    }

    destroy() {
        document.removeEventListener('click', this.handleOuterClick)
    }

    // handleClick = (event) => {
    //     if (event.target.closest('button')) {
    //         this.close()
    //     }
    // }

    handleOuterClick = (event) => {
        if (!this.element.contains(event.target)) {
            this.close()
        }
    }

    open() {
        this.element.classList.add(STATES.ACTIVE)
        EventBus.emit('lock:change', {
            status: 1,
        })
        document.addEventListener('click', this.handleOuterClick)
        document.body.style.overflow = 'hidden'
        document.body.style.height = '100vh'
        document.body.style.position = 'fixed'
        window.scrollTo(0, 0)
    }

    close() {
        this.element.classList.remove(STATES.ACTIVE)
        EventBus.emit('lock:change', {
            status: 0,
        })
        document.removeEventListener('click', this.handleOuterClick)
        document.body.style.overflow = 'unset'
        document.body.style.height = 'unset'
        document.body.style.position = 'static'
    }

    toggle() {
        if (this.is(STATES.ACTIVE)) {
            this.close()
        } else {
            this.open()
        }
    }
}
